const getActiveImage = require('./get_active_image')
const getFallbackImage = require('./get_fallback_image')

module.exports = function getUserActiveImage(user) {
    // get the user's active image
    const image = getActiveImage(user)
    if (image) return image

    // if no active image, return fallback
    return getFallbackImage()
}
